export default __webpack_public_path__ + "static/media/vip-ico-active.7d1f6a96.svg";